import { Constants } from "../helper/constants";
import jwt from "jwt-decode";
import IUser from "../models/user";
import { Utilities } from "./Utility";
import { ExternalApiService } from "../Services/External-API.service";

export default class TokenHelper {
  /**
   *
   */
  public static IsUserLoggedIn(): boolean {
    const token = TokenHelper.GetToken()!;
    return token !== undefined && token !== null && token.length > 0;
  }

  public static GetToken(): string {
    let token = localStorage.getItem(Constants.AccessTokenKey);
    if (token && token != null) {
      return token;
    }
    return "";
  }

  static count = 0;

  public static async InitializeUserData() {
    const token = TokenHelper.GetToken();
    if (!token) return;

    let decodedValue: any;
    try {
      decodedValue = jwt<any>(token);
    } catch {
      return;
    }
    let userEmail: string = TokenHelper.GetUserName(decodedValue);
    if (userEmail && userEmail.length > 0) {
      userEmail = userEmail.split("@")[0];
    }

    if (userEmail.toLowerCase().startsWith("t10029dipa") && this.count === 0) {
      while (this.count === 0) {
        try {
          this.count = 1;
          const testIdData: any = await ExternalApiService.getTestIds(
            userEmail.toUpperCase()
          );
          if (testIdData) {
            const extraUserData = {
              firstName: decodedValue.name,
              userEmail:
              testIdData.communicationEmail?.split("@")[0] || userEmail,
              companyCode: testIdData.companyCode,
              careerLevel: testIdData.careerLevel,
              location: testIdData.location,
              personnelNumber: testIdData.personnelNumber,
            };
            localStorage.removeItem("extraUserData");
            localStorage.setItem(
              "extraUserData",
              JSON.stringify(extraUserData)
            );
            return extraUserData;
          }
        } catch (error) {
          console.error("Error fetching test data:", error);
        }
      }
    }
  }

  // Generated by GitHub Copilot - Oct-05-2026
  /**
   * Resolves the user name across v1 (unique_name/upn) and v2 (preferred_username) access tokens.
   * @param decodedValue decoded JWT payload
   * @returns the user principal name, or an empty string when absent
   */
  private static GetUserName(decodedValue: any): string {
    return decodedValue?.unique_name ?? decodedValue?.upn ?? decodedValue?.preferred_username ?? decodedValue?.email ?? "";
  }

  public static DecodeToken(): IUser | null {
    const token = TokenHelper.GetToken();
    // Telemetry initializers call this before sign-in completes.
    if (!token) return null;
    let decodedValue: any;
    try {
      decodedValue = jwt<any>(token);
    } catch {
      // Stored value may be a non-JWT (e.g. "undefined") written by a failed token request.
      return null;
    }
    var userEmail: string = TokenHelper.GetUserName(decodedValue);
    var firstName: string = decodedValue.given_name ?? decodedValue.name?.split(" ")[0];
    var companyCode: string = decodedValue.companyCode;
    var correlationId = Math.round(Date.now() / 1000);
    var careerLevel: string = decodedValue.jobFamilyDescription;
    var jobTitle: string = decodedValue.jobTitle;
    var personnelNumber: string = decodedValue.personnelNumber;
    var location: string = decodedValue.location;

    if (userEmail && userEmail.length > 0) {
      userEmail = userEmail.split("@")[0];
    }

    if (userEmail.toLowerCase().startsWith("t10029dipa")) {
      while (this.count === 0) {
        const testIdData: any = TokenHelper.InitializeUserData();
        if (testIdData) {
          firstName = decodedValue.name;
          userEmail = testIdData.communicationEmail?.split("@")[0] || userEmail;
          companyCode = testIdData.companyCode || companyCode;
          careerLevel = testIdData.careerLevel || careerLevel;
          location = testIdData.location || location;
          personnelNumber = testIdData.personnelNumber || personnelNumber;
          this.count = 1;
        }
      }
    }
    const storedUserData = localStorage.getItem("extraUserData");

    if (storedUserData) {
      try {
        const extraData = JSON.parse(storedUserData);
        firstName = extraData.firstName || firstName;
        userEmail = extraData.userEmail || userEmail;
        companyCode = extraData.companyCode || companyCode;
        careerLevel = extraData.careerLevel || careerLevel;
        location = extraData.location || location;
        personnelNumber = extraData.personnelNumber || personnelNumber;
      } catch (error) {
        console.error("Error parsing stored user data:", error);
      }
    }

    return {
      candidateEnterpriseId: userEmail,
      accessToken: token!,
      enterpriseId: userEmail,
      isAuthenticated: true,
      firstName: firstName,
      CorrelationId: correlationId,
      careerLevel: careerLevel,
      companyCode: companyCode,
      IsAIGUser: Utilities.IsAIGUser(companyCode),
      jobTitle: jobTitle,
      personnelNumber: personnelNumber,
      location: location,
    };
  }
}
